import { Slot, SlotType } from '@frontend/slot/types';

export interface MoveDestinationSlotSelectableArgs {
    slot: Slot | null;
    isCurrentSource: boolean;
    isAvailable: boolean;
}

/** Destination SLOTs for move: available from API, not terminal, not the current source. */
export const isMoveDestinationSlotSelectable = (args: MoveDestinationSlotSelectableArgs): boolean =>
    !!args.slot && args.isAvailable && args.slot.type !== SlotType.TERMINAL && !args.isCurrentSource;
